<template>
  <div id="starter" class="starter">
    <div class="top">
      <p class="title">{{ $t('Home.starter.label') }}</p>
    </div>
    <div class="bottom">
      <div class="form">
        <div class="versions">
          <div class="data" :key="index" v-for="(version, index) in paas">
            <p class="label2" v-html="paasLabel(index, 'label')" />
            <!-- <p class="label1" v-html="paasLabel(index, 'price.main')" /> -->
            <!-- <p class="label3" v-html="paasLabel(index, 'price.space')" /> -->
            <div>
              <template v-for="(button, index) in paas[index].buttons">
                <el-popover :key="index" placement="right" width="12rem" trigger="hover">
                  <img style="width: 12rem; height: 12rem;" :src="qrcode" />
                  <el-button v-bind="button" size="small" slot="reference">{{ button.label }}</el-button>
                </el-popover>
              </template>
            </div>
            <el-table :data="paas[index].result.rows" height="100%" style="width: 400px" :show-header="false" size="medium" stripe>
              <el-table-column width="36"><i class="el-icon-caret-right" style="color:#40815B"></i></el-table-column>
              <el-table-column :key="index" v-bind="header" v-for="(header, index) in paas[index].headers" />
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const sprintf = require('sprintf-js').sprintf

export default {
  name: 'starter',
  data() {
    return {
      paas: [
        {
          label: this.$t('Home.starter.paas.1.label'),
          buttons: [{ prop: 'contact', type: 'primary', label: this.$t('Home.starter.button.contact.label') }],
          headers: [{ prop: 'value', label: this.$t('Home.starter.paas.1.header.value.label') }],
          result: {
            count: 6,
            rows: [
              { key: this.$t('Home.starter.paas.1.row.1.key'), value: this.$t('Home.starter.paas.1.row.1.value') },
              { key: this.$t('Home.starter.paas.1.row.2.key'), value: this.$t('Home.starter.paas.1.row.2.value') },
              { key: this.$t('Home.starter.paas.1.row.3.key'), value: this.$t('Home.starter.paas.1.row.3.value') },
              { key: this.$t('Home.starter.paas.1.row.4.key'), value: this.$t('Home.starter.paas.1.row.4.value') },
              { key: this.$t('Home.starter.paas.1.row.5.key'), value: this.$t('Home.starter.paas.1.row.5.value') },
              { key: this.$t('Home.starter.paas.1.row.6.key'), value: this.$t('Home.starter.paas.1.row.6.value') }
            ]
          }
        },
        {
          label: this.$t('Home.starter.paas.2.label'),
          buttons: [{ prop: 'contact', type: 'primary', label: this.$t('Home.starter.button.contact.label') }],
          headers: [{ prop: 'value', label: this.$t('Home.starter.paas.2.header.value.label') }],
          result: {
            count: 6,
            rows: [
              { key: this.$t('Home.starter.paas.2.row.1.key'), value: this.$t('Home.starter.paas.2.row.1.value') },
              { key: this.$t('Home.starter.paas.2.row.2.key'), value: this.$t('Home.starter.paas.2.row.2.value') },
              { key: this.$t('Home.starter.paas.2.row.3.key'), value: this.$t('Home.starter.paas.2.row.3.value') },
              { key: this.$t('Home.starter.paas.2.row.4.key'), value: this.$t('Home.starter.paas.2.row.4.value') },
              { key: this.$t('Home.starter.paas.2.row.5.key'), value: this.$t('Home.starter.paas.2.row.5.value') },
              { key: this.$t('Home.starter.paas.2.row.6.key'), value: this.$t('Home.starter.paas.2.row.6.value') }
            ]
          }
        },
        {
          label: this.$t('Home.starter.paas.3.label'),
          buttons: [{ prop: 'contact', type: 'primary', label: this.$t('Home.starter.button.contact.label') }],
          headers: [{ prop: 'value', label: this.$t('Home.starter.paas.3.header.value.label') }],
          result: {
            count: 6,
            rows: [
              { key: this.$t('Home.starter.paas.3.row.1.key'), value: this.$t('Home.starter.paas.3.row.1.value') },
              { key: this.$t('Home.starter.paas.3.row.2.key'), value: this.$t('Home.starter.paas.3.row.2.value') },
              { key: this.$t('Home.starter.paas.3.row.3.key'), value: this.$t('Home.starter.paas.3.row.3.value') },
              { key: this.$t('Home.starter.paas.3.row.4.key'), value: this.$t('Home.starter.paas.3.row.4.value') },
              { key: this.$t('Home.starter.paas.3.row.5.key'), value: this.$t('Home.starter.paas.3.row.5.value') },
              { key: this.$t('Home.starter.paas.3.row.6.key'), value: this.$t('Home.starter.paas.3.row.6.value') }
            ]
          }
        }
      ]
    }
  },
  computed: {
    qrcode: function() {
      return require('@/assets/qrcode.sales.png')
    }
  },
  methods: {
    paasLabel: function(index, name) {
      return this.$t(sprintf('Home.starter.paas.%s.%s', index + 1, name))
    }
  }
}
</script>

<style scoped>
.starter {
  width: 100%;
  height: 60rem;

  display: flex;
  flex-direction: column;
}

.starter .top {
  width: 100%;
  height: 8rem;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.starter .bottom {
  width: 100%;
  height: calc(100% - 8rem);
  padding-top: 2rem;

  display: flex;
  flex-direction: row;
  justify-content: center;
}

.top .title {
  font-size: 3.25rem;
  line-height: 4rem;
}

.bottom .form {
  border: 0.1rem solid #dedddd;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.form .versions {
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: row;
  justify-content: center;
}
.form .data {
  height: 100%;
  padding: 2rem 2rem 0.4rem;

  display: flex;
  flex-direction: column;
  align-items: center;
}
.form .label1 {
  font-size: 2.25rem;
  line-height: 3rem;
}
.form .label2 {
  font-size: 1.6rem;
  line-height: 2.4rem;
}
.form .label3 {
  font-size: 1.2rem;
  line-height: 2rem;
}
</style>
